module.exports = __webpack_public_path__ + "img/广告图二.3d4797c4.jpg";